import React, { useState, useEffect } from "react";
import Courses from "./Courses";
import UserSetting from "./UserSetting";
import Interview from "./Interview";
import CreditPoints from "./creditPoints";
import { useStores } from "../../store";
import { InterviewsCompleted } from "./dashboard";
import Experiences from "./experience";
import ViewCredits from "../dashboard/viewCredits";
import { IoPersonOutline, IoSettingsOutline } from "react-icons/io5";
import { PiExamLight, PiSuitcaseSimple } from "react-icons/pi";
import { AiOutlineDollar } from "react-icons/ai";
import PreviousSubscription from "../reusble_components/Pricing/previousSubscription";
import MoreSettings from "./moreSettings";
export default function BasicDetailsMobile() {
  const [activeTab, setActiveTab] = useState(1);
  const { UserStore } = useStores();
  const [user, setUser] = useState({});
  const [subscriptions, setSubscriptions] = useState([]);
  useEffect(() => {
    const subscriptions = UserStore.checkSubscription();
    setSubscriptions(subscriptions);
    console.log(subscriptions);
    const userDetail = localStorage.getItem("user");
    setUser(JSON.parse(userDetail));
    console.log(userDetail);
  }, []);
  return (
    <div>
      <div className="max-w-full w-fit mt-4">
        <div className="flex justify-content tc1:overflow-x-scroll   space-x-8 pt-2 px-5">
          <button
            onClick={() => setActiveTab(1)}
            className={`border-b-2 h-16 text-base ${
              activeTab === 1
                ? "border-primary text-primary"
                : "border-transparent"
            }`}
          >
            <span className="flex justify-center items-center gap-1 text-sm whitespace-nowrap  ">
              <IoPersonOutline />
              User Info
            </span>
          </button>
          <button
            onClick={() => setActiveTab(5)}
            className={`border-b-2 h-16 text-base ${
              activeTab === 5
                ? "border-primary text-primary text-primary"
                : "border-transparent"
            }`}
          >
            <span className="flex justify-center items-center gap-1 text-sm whitespace-nowrap  ">
              <PiSuitcaseSimple />
              Experience
            </span>
          </button>
          <button
            onClick={() => setActiveTab(2)}
            className={`border-b-2 text-base hidden  ${
              activeTab === 2
                ? "border-primary text-primary"
                : "border-transparent"
            }`}
          >
            Courses
          </button>
          <button
            onClick={() => setActiveTab(3)}
            className={`border-b-2 text-base  ${
              activeTab === 3
                ? "border-primary text-primary"
                : "border-transparent"
            }`}
          >
            <span className="flex justify-center items-center gap-1 text-sm whitespace-nowrap  ">
              <PiExamLight />
              Interview
            </span>
          </button>
          <button
            onClick={() => setActiveTab(4)}
            className={`border-b-2 text-base  ${
              activeTab === 4
                ? "border-primary text-primary"
                : "border-transparent"
            }`}
          >
            <span className="flex justify-center items-center gap-1 text-sm whitespace-nowrap  ">
              <AiOutlineDollar />
              Credits
            </span>
          </button>
          <button
            onClick={() => setActiveTab(6)}
            className={`border-b-2 text-base  ${
              activeTab === 6
                ? "border-primary text-primary"
                : "border-transparent"
            }`}
          >
            <span className="flex justify-center items-center gap-1 text-sm whitespace-nowrap  ">
              <AiOutlineDollar />
              Subscription
            </span>
          </button>
          <button
            onClick={() => setActiveTab(7)}
            className={`border-b-2 text-base  ${
              activeTab === 7
                ? "border-primary text-primary"
                : "border-transparent"
            }`}
          >
            <span className="flex justify-center items-center gap-1 text-sm whitespace-nowrap  ">
              <IoSettingsOutline />
              MoreSettings
            </span>
          </button>
        </div>
        {activeTab === 1 && <UserSetting />}
        {activeTab === 5 && <Experiences />}
        {activeTab === 2 && <Courses />}
        {activeTab === 3 && <Interview></Interview>}
        {activeTab === 6 && (
          <PreviousSubscription subscriptions={subscriptions} />
        )}
        {activeTab === 4 && (
          <div className="w-full border-t flex flex-col items-center mt-auto">
            <div className="m-auto flex flex-col md:flex-row lg:flex-row justify-center items-center my-2 w-[90%]">
              <CreditPoints
                className="w-[50%] "
                availableCredits={UserStore.userDetails?.coins ?? 0}
              />

              <div className=" md:w-[50%] lg:w-[50%] w-full lg:mt-7 md:mt-7">
                <InterviewsCompleted className="w-full " />
              </div>
              <div className="md:w-[50%] lg:w-[50%] w-full lg:mt-7 md:mt-7">
                <ViewCredits availableCredits={user?.coins ?? 0} />
              </div>
            </div>
            {/* {getMoreCreditsButton()} */}
          </div>
        )}
        {activeTab === 7 && <MoreSettings />}
      </div>
    </div>
  );
}
